module.exports = __webpack_public_path__ + "static/media/skype.1119d525.svg";